
export const CommonConfig = {

    baseLayers: [
        {
            id: "osm",
            label: "OpenStreetMap",
            type: "OSM",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_160/{z}/{x}/{y}.pbf",
            turned: true
        },
        // {
        //     id: "eeco",
        //     label: "ЕЭКО",
        //     type: "TMS",
        //     url: "https://rk.geosamara.ru/api/aeggis/v2/235/wmts/{z}/{x}/{y}.png",
        //     turned: false
        // },
        // {
        //     id: "satellite",
        //     label: "Спутник",
        //     type: "TMS",
        //     //url: "https://rk.geosamara.ru/api/aeggis/v2/36338/wmts/{z}/{x}/{y}.png",
        //     url: "https://maps.kosmosnimki.ru/TileSender.ashx?ModeKey=tile&ftc=osm&z={z}&x={x}&y={y}&srs=3857&sw=1&LayerName=4EE5E84381E94E369784464FD41EED5A",
        //     turned: false
        // }
    ]
}


